import React from 'react';

import { Col } from '@opendoor/atoms/box';
import { Navigate, Route, Routes, useLocation, useSearchParams } from 'react-router';

import { SUBSCRIPTION_PREFERENCES_ROUTE } from '../../src/routes/routes';
import ErrorPage from '../routes/ErrorPage';
import NotificationPreferences from './NotificationPreferences';

const PublicNotificationPreferences: React.FC<unknown> = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('id') || undefined;

  if (!userId && location.pathname === SUBSCRIPTION_PREFERENCES_ROUTE) {
    const errorEmail = 'partnerships@opendoor.com';
    return (
      <ErrorPage
        headerContent="Invalid preferences link"
        errorContent={
          <>
            <p>
              Please confirm that you are accessing this page using the link provided in an email
              from Opendoor.
            </p>
            <p>
              If you believe this is an error, email us at{' '}
              <a href={`mailto:${errorEmail}`}>{errorEmail}</a> if the problem persists.
            </p>
          </>
        }
      />
    );
  }

  const renderNotificationPreferencesWithProps = () => {
    return (
      <Col className="max-w-175 self-center">
        <NotificationPreferences userId={userId} />
      </Col>
    );
  };

  return (
    <Col className="min-h-dvh">
      <Routes>
        <Route
          index
          element={
            <Navigate
              to={{
                pathname: `${SUBSCRIPTION_PREFERENCES_ROUTE}/edit`,
                search: location.search,
              }}
              replace
            />
          }
        />
        <Route path="edit" element={renderNotificationPreferencesWithProps()} />
      </Routes>
    </Col>
  );
};

export default PublicNotificationPreferences;
